import { render, staticRenderFns } from "./entries-list.vue?vue&type=template&id=0dd25563&scoped=true"
import script from "./entries-list.vue?vue&type=script&lang=js"
export * from "./entries-list.vue?vue&type=script&lang=js"
import style0 from "./entries-list.vue?vue&type=style&index=0&id=0dd25563&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd25563",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dd25563')) {
      api.createRecord('0dd25563', component.options)
    } else {
      api.reload('0dd25563', component.options)
    }
    module.hot.accept("./entries-list.vue?vue&type=template&id=0dd25563&scoped=true", function () {
      api.rerender('0dd25563', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/entries/list/entries-list.vue"
export default component.exports